import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/gym/$venueUuid/challenges/$challengeUuid/")({
  component: () => <div>Hello /gym/$venueUuid/challenges/$challengeUuid/!</div>,
});
